"use strict";

// App shell (layout change, supersedes UX spec §3.1). Vanilla JS.
//
//   * Sidebar: expandable sections (saved per user), menus (New DM, user),
//     new-project dialog, mobile drawer.
//   * Counts: the global bell and per-project dots come from
//     /notifications.json (so the bell always equals the sum of the dots);
//     the project header's counts (one per lifecycle state, plus All tasks)
//     from <project>/shell.json. Both refresh on realtime events.
//   * Right panel: one panel at a time, beside the main pane. Views (Needs
//     you, one per lifecycle state, All tasks) and detail (task, unplanned)
//     load server-rendered fragments. All tasks filters client-side. Opening detail
//     from a view stacks it, with a back arrow. Close with X or Esc.
//   * Forms marked [data-ajax] (and card/panel forms) post with fetch, then
//     reload with the panel reopened, so every count shows derived truth.

(function () {
  var shellEl = document.getElementById('shell');
  if (!shellEl || !document.body.classList.contains('has-shell')) return;

  var meta = document.querySelector('meta[name="csrf-token"]');
  var csrf = meta ? meta.getAttribute('content') : null;
  var panel = document.getElementById('panel');
  var thread = document.querySelector('.thread[data-thread-mode="home"]');
  var pageBase = thread ? thread.getAttribute('data-base') : null;
  var actions = document.querySelector('[data-project-actions]');
  if (!pageBase && actions) pageBase = actions.getAttribute('data-counts-url').replace(/\/shell\.json$/, '');
  // The Organization module: its panel entries (invite, agents) hang off the org.
  var orgActions = document.querySelector('[data-org-actions]');
  if (!pageBase && orgActions) pageBase = orgActions.getAttribute('data-base');

  function stash(k, v) { try { sessionStorage.setItem(k, v); } catch (_e) {} }
  function take(k) { try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v; } catch (_e) { return null; } }
  function post(url, body, extra) {
    var headers = { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json', 'X-CSRF-Token': csrf };
    if (extra) Object.keys(extra).forEach(function (k) { headers[k] = extra[k]; });
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: headers, body: body.toString() });
  }

  // ── Toast (after an action, or after it reloads the page) ─────────────────
  function showToast(text) {
    var t = document.createElement('p');
    t.className = 'sh-toast'; t.setAttribute('role', 'status'); t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 5000);
  }
  var toast = take('rw:toast');
  if (toast) showToast(toast);

  // ── Sidebar sections (saved per user) ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    var tog = e.target.closest('[data-sb-toggle]');
    if (!tog) return;
    var sec = tog.closest('[data-sb-sec]');
    var body = sec && sec.querySelector('.sb-sec__body');
    if (!body) return;
    var open = body.hidden;
    body.hidden = !open;
    sec.classList.toggle('is-open', open);
    tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    var p = new URLSearchParams();
    p.set(tog.getAttribute('data-sb-toggle'), open ? 'true' : 'false');
    post('/me/ui-prefs', p).catch(function () {});
  });

  // ── Popup menus (New DM, user) ────────────────────────────────────────────
  function closeMenus(except) {
    document.querySelectorAll('[data-sb-menu]').forEach(function (m) {
      if (m === except) return;
      m.hidden = true;
      var b = m.parentNode.querySelector('[data-sb-menu-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-menu-btn]');
    if (btn) {
      e.stopPropagation();
      var menu = btn.parentNode.querySelector('[data-sb-menu]');
      var open = menu.hidden;
      closeMenus(menu);
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = menu.querySelector('a, button'); if (first) first.focus(); }
      return;
    }
    if (!e.target.closest('[data-sb-menu]')) closeMenus();
  });

  // ── New-project dialog (the "+" beside each org) ──────────────────────────
  var dlg = document.getElementById('newProjectDialog');
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-new-project]');
    if (add && dlg && typeof dlg.showModal === 'function') {
      e.preventDefault();
      var form = dlg.querySelector('[data-new-project-form]');
      form.action = '/org/' + add.getAttribute('data-new-project') + '/projects';
      dlg.querySelector('[data-new-project-org]').textContent = 'In ' + add.getAttribute('data-org-name');
      form.reset();
      dlg.showModal();
      return;
    }
    if (e.target.closest('[data-dialog-close]')) { var d = e.target.closest('dialog'); if (d) d.close(); }
  });

  // ── Mobile drawer ─────────────────────────────────────────────────────────
  var scrim = document.getElementById('shellScrim');
  function drawer(open) {
    shellEl.classList.toggle('shell--drawer', open);
    if (scrim) scrim.hidden = !open;
    var b = document.querySelector('[data-shell-drawer]');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-shell-drawer]')) { drawer(!shellEl.classList.contains('shell--drawer')); return; }
    if (e.target.closest('[data-shell-drawer-close]')) drawer(false);
  });

  // ── Counts ────────────────────────────────────────────────────────────────
  function setCount(el, n, quietZero) {
    if (!el) return;
    el.textContent = n > 99 ? '99+' : String(n || 0);
    el.hidden = !quietZero && !n;
    el.classList.toggle('is-zero', !n);
  }
  function refreshGlobal() {
    return fetch('/notifications.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        setCount(document.getElementById('globalBellCount'), d.count || 0);
        var by = {};
        (d.items || []).forEach(function (it) { by[it.project_id] = (by[it.project_id] || 0) + 1; });
        document.querySelectorAll('[data-attn-for]').forEach(function (dot) {
          var n = by[dot.getAttribute('data-attn-for')] || 0;
          dot.hidden = !n;
          dot.textContent = n ? String(n) : '';
          dot.setAttribute('aria-label', n + ' waiting on you');
        });
      })
      .catch(function () {});
  }
  function refreshProject() {
    if (!actions) return Promise.resolve();
    return fetch(actions.getAttribute('data-counts-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        Object.keys(d).forEach(function (k) {
          var el = actions.querySelector('[data-count="' + k + '"]');
          setCount(el, d[k], k !== 'attention');
        });
      })
      .catch(function () {});
  }
  var countTimer = null;
  function refresh() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      refreshGlobal(); refreshProject();
      // A list view reflects the same state: reload it in place.
      if (panel && !panel.hidden && current && current.view) load(current, { replace: true, quiet: true });
    }, 400);
  }
  refreshGlobal(); refreshProject();
  window.addEventListener('rushworks:message-event', function (ev) {
    var m = ev.detail && ev.detail.message;
    if (!m || (m.kind && m.kind !== 'human')) refresh();
  });
  window.addEventListener('rushworks:activity-event', refresh);
  if (window.io) {
    var sock = window.RushworksRealtime && window.RushworksRealtime.socket;
    if (!sock) sock = window.io({ transports: ['websocket', 'polling'] });
    sock.on('notification:event', refresh);
  }

  window.RushworksShell = { refresh: refresh };
  window.RushworksInbox = { refresh: refresh }; // older callers

  if (!panel) return;

  // ── Right panel ───────────────────────────────────────────────────────────
  var stack = [];      // entries: { view?, kind?, id?, url, base? }
  var current = null;
  var lastFocus = null;

  function detailUrl(kind, id, base) {
    if (kind === 'org' && id === 'new') return '/orgs/new?panel=1';
    var b = base || pageBase;
    if (!b) return null;
    if (kind === 'task') return b + '/tasks/' + encodeURIComponent(id) + '?panel=1';
    if (kind === 'unplanned') return b + '/unplanned?panel=1&key=' + encodeURIComponent(id);
    if (kind === 'doc') return b + '/docs/' + encodeURIComponent(id) + '?panel=1';
    if (kind === 'report') return b + '/report?panel=1' + (id ? '&days=' + encodeURIComponent(id) : '');
    if (kind === 'invite') return b + '/invite?panel=1';
    if (kind === 'agent') return b + '/agents/' + encodeURIComponent(id) + '?panel=1';
    if (kind === 'invoice') return b + '/invoices/' + encodeURIComponent(id) + '?panel=1';
    return null;
  }
  function markButtons() {
    document.querySelectorAll('[data-panel-view]').forEach(function (b) {
      var on = !!(current && current.view && b.getAttribute('data-panel-url') === current.url);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function hashFor(entry) {
    if (entry.view) return entry.global ? '#panel=attention-all' : '#panel=' + entry.view + (entry.tab ? ':' + entry.tab : '');
    return '#' + entry.kind + '=' + encodeURIComponent(entry.id);
  }
  // Two sizes: partial (default) and expanded over the main pane. Closing is
  // the X / Esc. The choice is remembered per viewer.
  var WIDE_KEY = 'rw:panel-wide';
  function wantWide() { try { return localStorage.getItem(WIDE_KEY) === '1'; } catch (_e) { return false; } }
  function setWide(on) {
    shellEl.classList.toggle('shell--panel-wide', !!on);
    try { localStorage.setItem(WIDE_KEY, on ? '1' : '0'); } catch (_e) {}
    var b = panel.querySelector('[data-panel-wide]');
    if (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Shrink panel' : 'Expand panel'); b.title = b.getAttribute('aria-label'); }
  }
  var WIDE_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>';
  function addWide() {
    var close = panel.querySelector('.panel__top [data-panel-close]');
    if (!close || panel.querySelector('[data-panel-wide]')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'panel__wide'; b.setAttribute('data-panel-wide', '');
    b.innerHTML = WIDE_SVG;
    close.parentNode.insertBefore(b, close);
    setWide(shellEl.classList.contains('shell--panel-wide'));
  }
  function addBack() {
    if (stack.length < 2) return;
    var top = panel.querySelector('.panel__top');
    if (!top || top.querySelector('[data-panel-back]')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'panel__back'; b.setAttribute('data-panel-back', '');
    b.setAttribute('aria-label', 'Back'); b.textContent = '←';
    top.insertBefore(b, top.firstChild);
  }
  function load(entry, opts) {
    opts = opts || {};
    if (!opts.quiet) panel.innerHTML = '<div class="panel__inner"><p class="panel__hint">Loading...</p></div>';
    // A live refresh keeps the cards selected in the Released list.
    var keepSel = opts.quiet ? [].map.call(panel.querySelectorAll('[data-bulk-id][aria-selected="true"]'), function (li) { return li.getAttribute('data-bulk-id'); }) : [];
    // A save reloads the entry: sections that were open stay open.
    var keepOpen = opts.quiet ? [].map.call(panel.querySelectorAll('details[open][id]'), function (d) { return d.id; }) : [];
    return fetch(entry.url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var scroll = opts.quiet ? panel.scrollTop : 0;
        panel.innerHTML = html;
        addBack();
        addWide();
        keepOpen.forEach(function (id) { var d = document.getElementById(id); if (d && panel.contains(d)) d.open = true; });
        initPanel(entry, !opts.quiet);
        if (scroll) panel.scrollTop = scroll;
        initFilters(panel);
        if (keepSel.length) {
          keepSel.forEach(function (id) {
            var li = panel.querySelector('[data-bulk-id="' + id + '"]');
            if (li) li.setAttribute('aria-selected', 'true');
          });
          bulkSync(panel.querySelector('[data-bulk-done]'));
        }
        if (!opts.quiet) {
          var focusEl = panel.querySelector('[data-panel-back], [data-panel-close]');
          // preventScroll: Settings may have scrolled to a section (settingsTab).
          if (focusEl) focusEl.focus({ preventScroll: true });
        }
        history.replaceState(null, '', location.pathname + location.search + hashFor(entry));
      })
      .catch(function () {
        panel.innerHTML = '<div class="panel__inner"><div class="panel__top"><p class="panel__hint">Could not load this. It may have been removed.</p>'
          + '<button class="panel__close" data-panel-close type="button" aria-label="Close">×</button></div></div>';
        addBack();
      });
  }
  // Settings: stacked sections in the partial panel; tabs when expanded. The
  // tab rides on the entry, so the hash and a reload keep it.
  function settingsTab(entry, scroll) {
    var root = panel.querySelector('[data-settings]');
    if (!root) return;
    var tab = entry.tab || 'general';
    if (!root.querySelector('[data-settings-section="' + tab + '"]')) tab = 'general';
    root.setAttribute('data-tab', tab);
    root.querySelectorAll('[data-settings-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-settings-tab') === tab ? 'true' : 'false');
    });
    if (scroll && entry.tab && !shellEl.classList.contains('shell--panel-wide')) {
      var sec = root.querySelector('[data-settings-section="' + tab + '"]');
      if (sec) sec.scrollIntoView({ block: 'start' });
    }
  }
  function initPanel(entry, scroll) {
    settingsTab(entry, scroll);
    if (window.RushworksSettings) window.RushworksSettings.init(panel);
  }
  function show(entry, push) {
    if (panel.hidden) lastFocus = document.activeElement;
    if (push) stack.push(entry); else stack = [entry];
    current = entry;
    panel.hidden = false;
    shellEl.classList.add('shell--panel');
    shellEl.classList.toggle('shell--panel-wide', wantWide());
    markButtons();
    return load(entry);
  }
  function openView(btn, tab) {
    var url = btn.getAttribute('data-panel-url');
    // Toggling the open view's button closes the panel.
    if (tab === undefined && !panel.hidden && current && current.view && current.url === url && stack.length === 1) { closePanel(); return; }
    show({ view: btn.getAttribute('data-panel-view'), url: url, global: btn.id === 'globalBell', tab: tab || '' }, false);
  }
  function openDetail(kind, id, base) {
    var url = detailUrl(kind, id, base);
    if (!url) return false;
    // From a list view, detail stacks (back arrow); otherwise it replaces.
    var push = !panel.hidden && !!current;
    show({ kind: kind, id: id, url: url, base: base }, push);
    return true;
  }
  function back() {
    if (stack.length < 2) return closePanel();
    stack.pop();
    current = stack[stack.length - 1];
    markButtons();
    load(current);
  }
  function closePanel() {
    panel.hidden = true; panel.innerHTML = '';
    shellEl.classList.remove('shell--panel', 'shell--panel-wide');
    stack = []; current = null;
    markButtons();
    history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    var v = e.target.closest('[data-panel-view]');
    if (v) { e.preventDefault(); drawer(false); openView(v); return; }
    if (e.target.closest('[data-panel-close]')) { e.preventDefault(); closePanel(); return; }
    if (e.target.closest('[data-panel-back]')) { e.preventDefault(); back(); return; }
    if (e.target.closest('[data-panel-wide]')) { e.preventDefault(); setWide(!shellEl.classList.contains('shell--panel-wide')); return; }
    if (e.target.closest('[data-panel-reload]') && current) { e.preventDefault(); load(current); return; }
    var st = e.target.closest('[data-settings-tab]');
    if (st && current) {
      current.tab = st.getAttribute('data-settings-tab');
      settingsTab(current, false);
      history.replaceState(null, '', location.pathname + location.search + hashFor(current));
      return;
    }
    // A link that opens in the panel: data-panel-open="doc:<slug>" | "report:<days>".
    var po = e.target.closest('[data-panel-open]');
    if (po) {
      var spec = po.getAttribute('data-panel-open'); var i = spec.indexOf(':');
      var viewBtn = document.querySelector('[data-project-actions] [data-panel-view="' + spec.slice(0, i) + '"]');
      if (viewBtn) { e.preventDefault(); openView(viewBtn, spec.slice(i + 1)); return; }
      if (openDetail(spec.slice(0, i), spec.slice(i + 1))) { e.preventDefault(); return; }
    }
    var tr = e.target.closest('[data-task-ref]');
    if (tr && openDetail('task', tr.getAttribute('data-task-ref'), tr.getAttribute('data-task-base'))) { e.preventDefault(); return; }
    var tg = e.target.closest('[data-tag-ref]');
    if (tg && openTasksWithTag(tg.getAttribute('data-tag-ref'))) { e.preventDefault(); return; }
    var ur = e.target.closest('[data-unplanned-ref]');
    if (ur && openDetail('unplanned', ur.getAttribute('data-unplanned-ref'))) { e.preventDefault(); return; }
    var mr = e.target.closest('[data-message-ref]');
    if (mr) {
      var el = document.getElementById('m-' + mr.getAttribute('data-message-ref'));
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.classList.add('chat__msg--flash'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.querySelector('dialog[open]')) return;
    if (shellEl.classList.contains('shell--drawer')) { drawer(false); return; }
    var openMenu = document.querySelector('[data-sb-menu]:not([hidden])');
    if (openMenu) { closeMenus(); return; }
    if (!panel.hidden) closePanel();
  });

  // A tag chip (or an old goal link, ?tag=<id>) opens All tasks filtered to it.
  function openTasksWithTag(id) {
    var btn = document.querySelector('[data-project-actions] [data-panel-view="tasks"]');
    if (!btn) return false;
    saveFilters({ tags: [String(id)], states: [], origin: '', type: '', done: false, q: '' });
    if (!panel.hidden && current && current.view === 'tasks') { applyFilters(panel, true); return true; }
    show({ view: 'tasks', url: btn.getAttribute('data-panel-url'), global: false }, false);
    return true;
  }

  // Reopen from the hash (#task=12, #panel=in_staging) or after an action reload.
  function fromHash(h) {
    var m = /^#(task|unplanned|doc|agent|invoice|org)=(.+)$/.exec(h || '') || /^#(report|invite)=(.*)$/.exec(h || '');
    if (m) return { kind: m[1], id: decodeURIComponent(m[2]) };
    var v = /^#panel=([a-z_-]+)(?::([a-z]+))?$/.exec(h || '');
    if (v) {
      var sel = v[1] === 'attention-all' ? '#globalBell' : '[data-project-actions] [data-panel-view="' + v[1] + '"]';
      return { button: document.querySelector(sel), tab: v[2] };
    }
    return null;
  }
  var reopen = fromHash(take('rw:reopen') || location.hash);
  if (!reopen && panel.getAttribute('data-open-kind')) {
    reopen = { kind: panel.getAttribute('data-open-kind'), id: panel.getAttribute('data-open-id') };
  }
  var tagParam = new URLSearchParams(location.search).get('tag');
  if (!reopen && tagParam) openTasksWithTag(tagParam);
  else if (reopen && reopen.button) openView(reopen.button, reopen.tab);
  else if (reopen && reopen.kind) openDetail(reopen.kind, reopen.id);

  // ── Released list: select cards, then Mark done on the selection ─────────
  // Clicking a card selects it, clicking it again unselects; links, buttons
  // and forms inside keep their own behaviour. Select all toggles every card.
  function bulkSync(form) {
    var list = document.querySelector('[data-bulk-list]');
    if (!form || !list) return;
    var cards = list.querySelectorAll('[data-bulk-id]');
    var picked = list.querySelectorAll('[data-bulk-id][aria-selected="true"]');
    form.querySelectorAll('input[name="task_ids"]').forEach(function (i) { i.remove(); });
    picked.forEach(function (li) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'task_ids'; i.value = li.getAttribute('data-bulk-id');
      form.appendChild(i);
    });
    var n = picked.length;
    var all = form.querySelector('[data-bulk-all]');
    if (all) { all.checked = n > 0 && n === cards.length; all.indeterminate = n > 0 && n < cards.length; }
    var count = form.querySelector('[data-bulk-count]');
    if (count) count.textContent = n ? n + ' selected' : 'Click tasks to select them';
    var btn = form.querySelector('[data-bulk-submit]');
    if (btn) { btn.hidden = !n; btn.textContent = n > 1 ? 'Mark ' + n + ' done' : 'Mark done'; }
    form.setAttribute('data-confirm', 'Mark ' + n + ' task' + (n === 1 ? '' : 's') + ' done?');
  }
  document.addEventListener('click', function (e) {
    var li = e.target.closest('[data-bulk-list] [data-bulk-id]');
    if (!li || e.target.closest('a, button, input, select, textarea, form, label')) return;
    li.setAttribute('aria-selected', li.getAttribute('aria-selected') === 'true' ? 'false' : 'true');
    bulkSync(document.querySelector('[data-bulk-done]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var li = e.target.matches && e.target.matches('[data-bulk-list] [data-bulk-id]') ? e.target : null;
    if (!li) return;
    e.preventDefault();
    li.setAttribute('aria-selected', li.getAttribute('aria-selected') === 'true' ? 'false' : 'true');
    bulkSync(document.querySelector('[data-bulk-done]'));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-bulk-all]')) return;
    var on = e.target.checked;
    document.querySelectorAll('[data-bulk-list] [data-bulk-id]').forEach(function (li) { li.setAttribute('aria-selected', on ? 'true' : 'false'); });
    bulkSync(e.target.closest('[data-bulk-done]'));
  });

  // ── Forms inside a panel page ([data-panel-forms]) ────────────────────────
  // A GET form (a period picker) reloads the panel entry with its query; a
  // POST saves with fetch and reloads the entry in place, keeping the scroll.
  // JSON {redirect} navigates; an HTML 409 (a confirm step) replaces the
  // panel's content.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!current || !form.closest('#panel [data-panel-forms]') || form.matches('[data-no-ajax]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var msg = form.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) return;
    var data = new FormData(form);
    if (e.submitter && e.submitter.name) data.set(e.submitter.name, e.submitter.value);
    if ((form.getAttribute('method') || 'get').toLowerCase() === 'get') {
      var q = new URLSearchParams(data); q.set('panel', '1');
      current.url = form.action.split('?')[0] + '?' + q.toString();
      if (current.kind === 'report') current.id = q.get('days') || '';
      load(current);
      return;
    }
    var btns = form.querySelectorAll('button'); btns.forEach(function (b) { b.disabled = true; });
    post(form.action, new URLSearchParams(data), { 'X-Panel': '1' })
      .then(function (r) {
        if (r.status === 409 && /text\/html/.test(r.headers.get('content-type') || '')) {
          return r.text().then(function (html) { panel.innerHTML = html; addBack(); addWide(); panel.scrollTop = 0; return null; });
        }
        return r.json().catch(function () { return { ok: r.ok, error: 'HTTP ' + r.status }; });
      })
      .then(function (d) {
        if (d === null) return;
        if (!d || d.ok === false) throw new Error((d && d.error) || 'That did not work');
        if (d.redirect) { location.href = d.redirect; return; }
        // next: 'back' returns to the entry this one stacked on (it reloads);
        // 'reload' refreshes the page behind, panel closed; 'open:<kind>=<id>'
        // refreshes it with that entry open (a just-added agent).
        if (d.next === 'back' && stack.length > 1) { if (d.message) showToast(d.message); back(); return; }
        if (d.next === 'reload' || /^open:/.test(d.next || '')) {
          if (d.message) stash('rw:toast', d.message);
          if (d.next !== 'reload') stash('rw:reopen', '#' + d.next.slice(5));
          history.replaceState(null, '', location.pathname + location.search);
          location.reload();
          return;
        }
        if (d.message) showToast(d.message);
        return load(current, { quiet: true });
      })
      .catch(function (err) {
        btns.forEach(function (b) { b.disabled = false; });
        var note = form.querySelector('.form-error') || document.createElement('p');
        note.className = 'panel__hint form-error';
        note.textContent = err.message;
        form.appendChild(note);
      });
  }, true);

  // ── AJAX forms (panel + cards) ────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax], .tc form')) return;
    var msg = form.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) { e.preventDefault(); return; }
    e.preventDefault();
    var body = new URLSearchParams(new FormData(form));
    if (e.submitter && e.submitter.name) body.set(e.submitter.name, e.submitter.value);
    var btns = form.querySelectorAll('button');
    btns.forEach(function (b) { b.disabled = true; });
    post(form.action, body)
      .then(function (r) { return r.json().catch(function () { return { ok: r.ok, error: 'HTTP ' + r.status }; }); })
      .then(function (d) {
        if (!d || d.ok === false) throw new Error((d && d.error) || 'That did not work');
        if (!panel.hidden && current) stash('rw:reopen', hashFor(stack[0] && stack[0].view ? stack[0] : current));
        stash('rw:toast', d.message || (d.task_id ? ('Done. Task #' + d.task_id + '.') : 'Done.'));
        location.reload();
      })
      .catch(function (err) {
        btns.forEach(function (b) { b.disabled = false; });
        var note = form.querySelector('.form-error') || document.createElement('p');
        note.className = 'panel__hint form-error';
        note.textContent = err.message;
        form.appendChild(note);
      });
  });

  // ── All tasks: filters (client-side, over the server-rendered list) ───────
  // Tag chips (multi-select, AND), state chips (any of), origin, type, Show
  // done, text search. Kept per project for this tab, so an action's reload
  // comes back to the same filtered list.
  var FKEY = 'rw:tf:' + (pageBase || '');
  function loadFilters() {
    try { return JSON.parse(sessionStorage.getItem(FKEY)) || null; } catch (_e) { return null; }
  }
  function saveFilters(f) { try { sessionStorage.setItem(FKEY, JSON.stringify(f)); } catch (_e) {} }
  function readFilters(root) {
    var f = { tags: [], states: [], origin: '', type: '', done: false, q: '' };
    root.querySelectorAll('[data-tf-tag][aria-pressed="true"]').forEach(function (b) { f.tags.push(b.getAttribute('data-tf-tag')); });
    root.querySelectorAll('[data-tf-state][aria-pressed="true"]').forEach(function (b) { f.states.push(b.getAttribute('data-tf-state')); });
    var o = root.querySelector('[data-tf-origin]'); if (o) f.origin = o.value;
    var t = root.querySelector('[data-tf-type]'); if (t) f.type = t.value;
    var d = root.querySelector('[data-tf-done]'); if (d) f.done = d.checked;
    var q = root.querySelector('[data-tf-search]'); if (q) f.q = q.value.trim().toLowerCase();
    return f;
  }
  function writeFilters(root, f) {
    root.querySelectorAll('[data-tf-tag]').forEach(function (b) {
      b.setAttribute('aria-pressed', f.tags.indexOf(b.getAttribute('data-tf-tag')) >= 0 ? 'true' : 'false');
    });
    root.querySelectorAll('[data-tf-state]').forEach(function (b) {
      b.setAttribute('aria-pressed', f.states.indexOf(b.getAttribute('data-tf-state')) >= 0 ? 'true' : 'false');
    });
    var o = root.querySelector('[data-tf-origin]'); if (o) o.value = f.origin || '';
    var t = root.querySelector('[data-tf-type]'); if (t) t.value = f.type || '';
    var d = root.querySelector('[data-tf-done]'); if (d) d.checked = !!f.done;
    var q = root.querySelector('[data-tf-search]'); if (q) q.value = f.q || '';
  }
  function applyFilters(root, fromStore) {
    var box = root.querySelector('[data-task-filters]');
    if (!box) return;
    var f = fromStore ? (loadFilters() || readFilters(box)) : readFilters(box);
    if (fromStore) writeFilters(box, f);
    // Picking the Done state chip implies showing Done.
    var showDone = f.done || f.states.indexOf('done') >= 0;
    var shown = 0;
    root.querySelectorAll('[data-tf-row]').forEach(function (li) {
      var tags = (li.getAttribute('data-tags') || '').split(',').filter(Boolean);
      var st = li.getAttribute('data-state');
      var ok = (st !== 'done' || showDone)
        && f.tags.every(function (id) { return tags.indexOf(id) >= 0; })
        && (!f.states.length || f.states.indexOf(st) >= 0)
        && (!f.origin || li.getAttribute('data-origin') === f.origin)
        && (!f.type || li.getAttribute('data-type') === f.type)
        && (!f.q || (li.getAttribute('data-text') || '').indexOf(f.q) >= 0);
      li.hidden = !ok;
      if (ok) shown++;
    });
    var c = root.querySelector('[data-tf-count]');
    if (c) c.textContent = shown + (shown === 1 ? ' task' : ' tasks');
    var empty = root.querySelector('[data-tf-empty]');
    if (empty) empty.hidden = shown > 0;
    saveFilters(f);
  }
  function initFilters(root) {
    var box = root.querySelector('[data-task-filters]');
    if (!box || box.getAttribute('data-bound')) return;
    box.setAttribute('data-bound', '1');
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-tf-tag], [data-tf-state]');
      if (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        applyFilters(root);
        return;
      }
      if (e.target.closest('[data-tf-clear]')) {
        writeFilters(box, { tags: [], states: [], origin: '', type: '', done: false, q: '' });
        applyFilters(root);
      }
    });
    box.addEventListener('change', function () { applyFilters(root); });
    box.addEventListener('input', function (e) { if (e.target.matches('[data-tf-search]')) applyFilters(root); });
    applyFilters(root, true);
  }

})();
